import gql from 'graphql-tag'

export const GET_SHOPS = gql`
  query shop {
    shops(input:{
      orderBy: DESC
    }) {
      totalCount
      lists {
        id
        shopname
        phonenumber
      }
    }
  }
`

export const GET_BARBERS = gql`
  query barbers(
    $shopId: Int
    $serviceId: [Int]
  ) {
    barbers(
      input: {
        shopId: $shopId
        serviceId: $serviceId
      }
    ) {
      totalCount
      lists {
        id
        barberName
        description
        barberImage
        workdays {
          date
        }
      }
    }
  }
`

export const GET_APPOINMENT = gql`
  query appointments(
    $shopId: Int!
    $serviceId: [Int]!
    $barberId: Int
    $date: Date!
  ) {
    appointments(input:{
      shopId: $shopId
      serviceId: $serviceId
      barberId: $barberId
      date: $date
    }){
      isSuccess
      message
      data{
        lists{
          start
          end
          isSuccess
          appointment{
            id
            isPreference
          }
        }
        totalCount
        totalFilter
      }
    }
  }
`
export const GET_SERVICES = gql`
  query getServices (
    $shopId: Int
  ) {
    serviceTypes(input:{
      shopId: $shopId
    }){
      lists{
        id
        categoryName
        services{
          id
          serviceName
          price
          time
          description
          isMinimum
        }
      }
    }
  }
`
export const MY_APPOINTMENT = gql`
  query getMyAppointment {
    myWatingAppointment{
      appointment{
        id
        start
        end
        status
        services{
          id
          time
          serviceName
          price
        }
        shop {
          shopname
        }
        barber{
          id
          barberName
          barberImage
        }
      }
      message
      success
    }
  }
`

export const GET_USER = gql`
  query getUser(
    $userId: Int!
  ) {
    user(input:{
      userId: $userId
    }){
      id
      firstname
      lastname
      email
      phonenumber
    }
  }
`

export const ME = gql`
  query me {
    me{
      id
      firstname
      lastname
      email
      phonenumber
    }
  }
`

export const GET_ME = gql`
  query me {
    me {
      id
      firstname
      lastname
      phonenumber
    }
  }
`

export default GET_SHOPS



// WEBPACK FOOTER //
// ./src/constants/graphql/query.js